import { esc } from './dom';

export interface FilterChipsOptions<T extends string> {
  values: { value: T; label: string; count?: number }[];
  active: T | 'all';
  allLabel?: string;
}

export function renderFilterChips<T extends string>(opts: FilterChipsOptions<T>): string {
  const all = opts.allLabel ?? 'All';
  const total = opts.values.reduce((s, v) => s + (v.count ?? 0), 0);
  const chip = (val: string, label: string, count: number | undefined, active: boolean): string =>
    `<button type="button" class="filter-chip ${active ? 'is-active' : ''}" data-filter-value="${esc(val)}">${esc(label)}${count != null ? ` <span class="filter-chip-count">${count}</span>` : ''}</button>`;
  return `<div class="filter-chips" role="tablist">
    ${chip('all', all, opts.values[0]?.count == null ? undefined : total, opts.active === 'all')}
    ${opts.values.map((v) => chip(v.value, v.label, v.count, opts.active === v.value)).join('')}
  </div>`;
}

export function bindFilterChips<T extends string>(
  root: ParentNode,
  onChange: (value: T | 'all') => void,
): void {
  root.querySelectorAll<HTMLButtonElement>('.filter-chip').forEach((btn) => {
    btn.addEventListener('click', () => {
      onChange(btn.dataset.filterValue as T | 'all');
    });
  });
}
